import axios from 'axios';
import sha1 from 'sha1';
import config from '../../config';

const DEFAULT_AUTHORIZATION = 'fz6031df8ygcx9dbedjh24h5tuj2m1sgv9txbrut11e1gzoftlc5m1iqvig5uvvi';
const DEFAULT_VID = 1750863069;
const DEFAULT_NAME = 'Donasi';
const PAYMENT_URL = '/gateway/payments';

const request = axios.create({
  baseURL: config.baseUrl,
  headers: {
    'Api-Key': config.apiKey,
    'G-Channel': 7,
  },
});

/**
 *
 * @param {import('axios').AxiosResponse} response
 * @returns
 */
function parseResponse(response) {
  const responseBody = response.data;

  return {
    httpStatus: response.status,
    isError: responseBody.code === 0,
    data: responseBody.data,
    message: responseBody.data && responseBody.data.status_msg
      ? responseBody.data.status_msg
      : responseBody.message,
  };
}

export async function postDonation({
  price, email, name, phone, code, itemName, vid,
}) {
  const response = await request.post(PAYMENT_URL, {
    vid: vid || DEFAULT_VID,
    reference_id: `${new Date().toISOString()}_${sha1(name + email + phone)}`,
    items: [{
      name: itemName || DEFAULT_NAME,
      qty: 1,
      price,
    }],
    buyer: { email, name, phone },
  }, {
    headers: {
      Authorization: code || DEFAULT_AUTHORIZATION,
    },
  });

  return parseResponse(response);
}
